import {z} from 'zod';

export const warrantyProgramFormSchema = z.object({
  name: z.string().trim().min(1),
  duration: z.number().int().min(1).nullable(),
  watermarkId: z.string().uuid().nullable(),
  termsAndConditions: z.record(z.string()),
});

export type WarrantyProgramFormValues = z.infer<typeof warrantyProgramFormSchema>;
